(() => {
  const GIFT_VARIANT_ID = 54000415998299;
  const SERAX_VENDOR = 'Serax';
  const THRESHOLD = 15000; // 150 € en céntimos

  let isProcessing = false;

  const getCart = async () => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');

    if (!response.ok) {
      throw new Error('No se pudo obtener el carrito');
    }

    return response.json();
  };

  const addGift = async () => {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: GIFT_VARIANT_ID,
            quantity: 1,
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error('No se pudo añadir el regalo');
    }

    return response.json();
  };

  const removeGift = async (giftLine) => {
    const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: giftLine.key,
        quantity: 0,
      }),
    });

    if (!response.ok) {
      throw new Error('No se pudo eliminar el regalo');
    }

    return response.json();
  };

  const checkSeraxGift = async () => {
    if (isProcessing) return;

    isProcessing = true;

    try {
      const cart = await getCart();

      const giftLine = cart.items.find(
        (item) => Number(item.variant_id) === GIFT_VARIANT_ID
      );

      const seraxTotal = cart.items
        .filter(
          (item) =>
            item.vendor === SERAX_VENDOR &&
            Number(item.variant_id) !== GIFT_VARIANT_ID
        )
        .reduce((total, item) => total + item.final_line_price, 0);

      const qualifies = seraxTotal >= THRESHOLD;

      if (qualifies && !giftLine) {
        await addGift();

        console.log('[Serax Gift] Regalo añadido automáticamente');
      }

      if (!qualifies && giftLine) {
        await removeGift(giftLine);

        console.log('[Serax Gift] Regalo eliminado automáticamente');
      }

      if (qualifies && giftLine && giftLine.quantity > 1) {
        const response = await fetch(
          window.Shopify.routes.root + 'cart/change.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: giftLine.key,
              quantity: 1,
            }),
          }
        );

        if (!response.ok) {
          throw new Error('No se pudo limitar el regalo a 1 unidad');
        }
      }
    } catch (error) {
      console.error('[Serax Gift]', error);
    } finally {
      isProcessing = false;
    }
  };

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    try {
      const url =
        typeof args[0] === 'string'
          ? args[0]
          : args[0]?.url || '';

      const isCartRequest =
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update');

      if (isCartRequest) {
        setTimeout(checkSeraxGift, 150);
      }
    } catch (error) {
      console.error('[Serax Gift] Error al detectar actualización del carrito', error);
    }

    return response;
  };

  document.addEventListener('DOMContentLoaded', checkSeraxGift);

  checkSeraxGift();
})();